module.exports = __webpack_public_path__ + "73e59b778bdfe64e.svg";